import Icon from "@react-native-vector-icons/material-design-icons/static";
import { useState } from "react";
import { Card, List } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import MarkdownRenderer from "../MarkdownRenderer";
import ScrollContainer from "../ScrollContainer";

export type FaqItem = {
	question: string;
	answer: string;
	locale?: string;
	order?: number;
};

type Props = {
	faqs: FaqItem[];
	appFont?: string;
};

const FaqItemView = ({ faq, appFont }: { faq: FaqItem; appFont?: string }) => {
	const theme = useAppTheme();
	const [expanded, setExpanded] = useState(false);

	return (
		<Card
			mode="outlined"
			style={{ borderRadius: theme.roundness, marginBottom: 8 }}
		>
			<List.Accordion
				left={(props) => (
					<Icon {...props} name={"message-question-outline"} size={16} />
				)}
				titleNumberOfLines={2}
				title={faq.question}
				expanded={expanded}
				onPress={() => setExpanded(!expanded)}
				style={{
					paddingVertical: 0,
					paddingHorizontal: 8,
					backgroundColor: expanded
						? theme.colors.elevation.level2
						: theme.colors.surface,
				}}
			>
				<List.Item
					title={() => <MarkdownRenderer text={faq.answer} appFont={appFont} />}
					titleNumberOfLines={8}
				/>
			</List.Accordion>
		</Card>
	);
};

const FaqsList = ({ faqs, appFont }: Props) => {
	return (
		<ScrollContainer>
			<Box padding={16} paddingBottom={84}>
				{faqs.map((faq) => (
					<FaqItemView key={faq.question} faq={faq} appFont={appFont} />
				))}
			</Box>
		</ScrollContainer>
	);
};

export default FaqsList;
